import { createComponent } from "@helpers/admin";
import DeliveryTermsSectionComponent from "@template/blocks/DeliveryTermsSection/component";

export const DeliveryTerms = createComponent({
  label: "Delivery Terms",
  component: DeliveryTermsSectionComponent,
  fields: {
    title: {
      label: "Title",
      type: "text",
    },
    subTitle: {
      label: "Sub Title",
      type: "markdown",
    },
    links: {
      label: "Links",
      type: "array",
      arrayFields: {
        label: {
          label: "Label",
          type: "text",
        },
        href: {
          label: "Link",
          type: "text",
        },
      },
    },
    showContent: {
      label: "Show Content",
      type: "boolean",
    },
    content: {
      label: "Content",
      type: "markdown",
    },
    sections: {
      label: "Sections",
      type: "array",
      arrayFields: {
        title: {
          label: "Title",
          type: "markdown",
        },
        content: {
          label: "Content",
          type: "array",
          arrayFields: {
            text: {
              label: "Text",
              type: "markdown",
            },
          },
        },
      },
    },
  },
});
